export const CREATE_JAR="jar/create_jar";
export const UPDATE_JAR="jar/update_jar";
export const DELETE_JAR="jar/delete_jar";
export const FETCH_ALL_JARS= "jar/fetch_all_jars";
export const UPDATE_JAR_ARRAY="jar/update_jars_array";



export const CREATE_MOVEMENT="movement/create_movement";
export const UPDATE_MOVEMENT= "movement/update_movement";
export const DELETE_MOVEMENT= "movement/delete_movement";
export const FETCH_ALL_MOVEMENTS= "movement/fetch_all_movements";

export const SELECTED_JAR="selected/selected_jar";
export const SELECTED_MOVEMENT="selected/selected_movement";
export const UNSELECTED_MOVEMENT="selected/unselected_movement";
export const UNSELECTED_JAR="selected/unselected_jar";


// export const FETCH_ALL_TRANSACTIONS= "transaction/fetch_all_transactions";
// export const CREATE_TRANSACTION="transaction/create_transaction";
// export const DELETE_TRANSACTION= "transaction/delete_transaction";


// export const SETTING_FORM_FOR_INCOME="selected/setting_form_purpose_to_add_income";
// export const SETTING_FORM_FOR_EXPENSE="selected/setting_form_purpose_to_add_expense";
// export const SETTING_FORM_FOR_ADDING_JAR="selected/setting_form_purpose_to_add_jar";
// export const SETTING_FORM_FOR_EDIT_JAR="selected/setting_form_purpose_to_edit_jar";
// export const SETTING_FORM_FOR_EDIT_MOVEMENT="selected/setting_form_purpose_to_edit_movement";
// export const SETTING_FORM_FOR_TRANSER_MONEY="selected/setting_form_purpose_to_transfer_money";
// export const SETTING_FORM_FOR_DISTRIBUTE_PERCENTAGES="selected/setting_form_purpose_to_distribute_percentages";
export const SETTING_FORM_PURPOSE="selected/setting_form_purpose";
export const CLEAR_FORM_PURPOSE="selected/clear_form_purpose";
export const SETTING_USER="selected/setting_user";
export const CLEAR_USER="selected/clear_user";

export const CREATE_USER="user/create_user";
export const FETCH_USER= "user/fetch_user";





